import { NgModule } from '@angular/core';
import { AutoCompleteComponent } from './auto-complete.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatFormFieldModule, MatAutocompleteModule, MatInputModule } from '@angular/material';

@NgModule({
    declarations: [AutoCompleteComponent],
    imports: [FuseSharedModule, MatFormFieldModule, MatAutocompleteModule, MatInputModule],
    exports: [AutoCompleteComponent]
})
export class AutoCompleteModule {}
